import React from "react";
import Papa from "papaparse";
import { Button } from "components/common";
import { useDispatch, useSelector } from "react-redux";
import { clearBatch } from "state/reducers/emailBatching";
import { useHistory } from "react-router";
import MarketingNavigation from "../utils/components/MarketingNavigation";
import EmailMarketingStepper from "../utils/components/email/EmailMarketingStepper";
import MarketingToolTip from "../utils/components/MarketingToolTip";

const EmailResults = () => {
  const { batchResults: results = [], batchName } = useSelector(
    (state) => state.emailBatching,
  );
  const dispatch = useDispatch();
  const history = useHistory();
  const fileDownload = () => {
    const csv = Papa.unparse(results);
    console.log("unparsed json", csv);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `${batchName}.csv`);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  const Row = ({ title, value, className }) => (
    <div className={`flex justify-center text-lg ${className}`}>
      <p className="font-semibold pr-1">{`${title}:`}</p>
      <p>{value}</p>
    </div>
  );
  return (
    <div className="flex flex-col h-full">
      <MarketingNavigation />
      <EmailMarketingStepper />
      <p className="font-bold text-2xl text-center mb-4">Batch Emails</p>
      <div>
        <p className="text-center font-light text-3xl mt-6">Results</p>
        <div className="mt-4">
          <Row
            title="Total emails attempted"
            value={results.filter((r) => r.email).length}
          />
          <Row
            title="Total emails sent successfully"
            value={results.filter((r) => r.success).length}
            className="mt-1"
          />
          <Row
            title="Total emails sent unsuccessfully"
            value={results.filter((r) => !r.success).length}
            className="mt-1"
          />
          <div className="flex flex-col items-center justify-center mt-4">
            <button
              type="button"
              className="border-black border-b flex rounded-none items-center"
              onClick={fileDownload}
            >
              <i className="fas fa-file-download px-0 pr-1" />
              <p>Download CSV</p>
            </button>
            <Button
              className="mt-16"
              green
              onClick={() => {
                dispatch(clearBatch());
                history.push("/marketing");
              }}
            >
              Home
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailResults;
